import Model from './Model'

export default class Booking extends Model {
    resource()
    {
        return 'bookings'
    }
}